var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_Gui_admin"},[(_vm.regulationFile.length>0)?_c('custom-editor-readonly',{attrs:{"readonly":true,"min-height":(_vm.screenHeight * 0.50 - 20) + 'px'},model:{value:(_vm.regulationFile),callback:function ($$v) {_vm.regulationFile=$$v},expression:"regulationFile"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }